export enum MarketStatus {
  buyNow = 0,
  onAuction = 1,
  new = 3,
  hasOffers = 4,
}
